import React from 'react'

import LandingPage from '../LandingPage'

const Unauthenticated = () => {
    return <LandingPage />
}

export default Unauthenticated
